<div class="card md:p-5 p-2">
  @if (initialized && interactionType) {
    <h3 class="text-color md:p-0 p-2 pb-0">{{ interactionType.euName }}</h3>
  }

  @if (initialized && interactionData && interactionData.step) {

    @if (interactionData.step == "intro") {

      <app-interaction-intro
        [interactionData]="interactionData"
        [busy]="busy"
      ></app-interaction-intro>

    } @else if (interactionData.step == "form") {

      <app-interaction-form
        [interactionData]="interactionData"
        [busy]="busy"
      ></app-interaction-form>

    } @else if (interactionData.step == "schedule") {

      <app-interaction-schedule
        [interactionData]="interactionData"
        [busy]="busy"
      ></app-interaction-schedule>

    } @else if (interactionData.step == "final") {

      <app-interaction-final
        [interactionData]="interactionData"
        [busy]="busy"
      ></app-interaction-final>

    }

  }

<!--  <div class="flex mt-6 md:justify-content-end justify-content-center mb-4">-->
<!--    @if (buttonsData && buttonsData.previous) {-->
<!--      <p-button [disabled]="busy"-->
<!--                (click)="handlePreviousStep()"-->
<!--                label="Zurück"-->
<!--                severity="secondary"-->
<!--                [text]="true"-->
<!--                iconPos="left"-->
<!--                icon="pi pi-arrow-left">-->
<!--      </p-button>-->
<!--    }-->
<!--    @if (buttonsData && buttonsData.next) {-->
<!--      <p-button label="Weiter" (onClick)="handleNextStep()" styleClass="w-16rem"></p-button>-->
<!--    }-->
<!--    @if (buttonsData && buttonsData.finalize) {-->
<!--      <p-button label="Abschließen" (onClick)="handleFinalize()" styleClass="w-16rem"></p-button>-->
<!--    }-->
<!--  </div>-->

  <hr class="mt-8" *ngIf="buttonsData && (buttonsData.previous || buttonsData.next || buttonsData.finalize || buttonsData.overview)">

  <div class="grid mt-2">
    <div class="col-6">
      @if (buttonsData && buttonsData.previous) {
<!--        <p-button [disabled]="busy"-->
<!--                  (click)="handlePreviousStep()"-->
<!--                  label="Zurück"-->
<!--                  severity="secondary"-->
<!--                  [text]="true"-->
<!--                  iconPos="left"-->
<!--                  icon="pi pi-arrow-left">-->
<!--        </p-button>-->

        <app-button [busy]="busy"
                    [disabled]="busy"
                    [label]="'Zurück'"
                    [iconPos]="'left'"
                    [icon]="'pi pi-arrow-left'"
                    (onClick)="handlePreviousStep()">
        </app-button>

      }
    </div>
    <div class="col-6 flex justify-content-end">
      @if (buttonsData && buttonsData.next) {
<!--        <p-button label="Weiter" (onClick)="handleNextStep()" styleClass="mr-2"></p-button>-->
        <app-button [busy]="busy"
                    [label]="'Weiter'"
                    [class]="'mr-2'"
                    (onClick)="handleNextStep()">
        </app-button>
      }
      @if (buttonsData && buttonsData.finalize) {

<!--        <p-button label="Abschließen" (onClick)="handleFinalize()"></p-button>-->
        <app-button [busy]="busy"
                    [label]="'Absenden'"
                    (onClick)="handleFinalize()">
        </app-button>
      }
    </div>
  </div>





</div>
